import {
  Form,
  FormField,
  IFormField,
  MinLengthValidator,
  RequiredValidator,
} from '@thinknimble/tn-forms'
import { templateCategoryEnum } from './models'

/**
 * Authoring form for a custom WhatsApp template. `organization` is supplied by
 * the page from the selected org (not a field here); the remaining fields map
 * straight onto `createWhatsappTemplateShape`.
 */
export type WhatsappTemplateFormInputs = {
  // `_name` (not `name`) — a static `name` on the Form subclass collides with
  // the built-in `Function.name`.
  _name: IFormField<string>
  category: IFormField<string>
  language: IFormField<string>
  body: IFormField<string>
}

export class WhatsappTemplateForm extends Form<WhatsappTemplateFormInputs> {
  static _name = FormField.create({
    label: 'Name',
    placeholder: 'order_confirmation',
    type: 'text',
    value: '',
    validators: [
      new RequiredValidator({ message: 'Enter a template name' }),
      new MinLengthValidator({ minLength: 2, message: 'Name is too short' }),
    ],
  })

  static category = FormField.create({
    label: 'Category',
    type: 'text',
    value: templateCategoryEnum.UTILITY,
    validators: [new RequiredValidator({ message: 'Pick a category' })],
  })

  static language = FormField.create({
    label: 'Language',
    type: 'text',
    value: 'en',
    validators: [new RequiredValidator({ message: 'Pick a language' })],
  })

  static body = FormField.create({
    label: 'Message body',
    placeholder: 'Hi {{customer_name}}, this is {{org_name}}…',
    type: 'text',
    value: '',
    validators: [
      new RequiredValidator({ message: 'Enter the message body' }),
      new MinLengthValidator({ minLength: 3, message: 'Message body is too short' }),
    ],
  })
}

export type TWhatsappTemplateForm = WhatsappTemplateForm & WhatsappTemplateFormInputs
